import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { AssignUserGrid } from './AssignUserGrid';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { Filter, Main } from 'Containers';
import { DirtyWrapper } from 'Components';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { resetDirty } from 'State/dirtyTracking/actions';
import {
  clearAssignSiteData,
  getUsersForAssign,
} from './../state/assignUsers/actions';
import { postUsersHaveAccess } from './../state/page/actions';

class AssignUserPage extends Component {
  static path = '/sitesetup/assignusers/:id/:showLicensed/:description';
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getUsersForAssign(id);
  }

  handleAssignSubmit = () => {
    const { showLicensed, id } = this.props.match.params;
    //get data into the format userid [sites]
    const userIds = this.props.assignUserData
      .filter(x => x.Allowed)
      .map(x => {
        if (x.Allowed) {
          x.Allowed = 1;
        } else {
          x.Allowed = 0;
        }
        return x;
      });

    this.props.postUsersHaveAccess(
      {
        SiteId: id,
        AccessibleUserInfos: userIds,
      },
      showLicensed
    );
    this.props.resetDirty();
  };
  getRootUrl = () => {
    return '/sitesetup';
  };
  getMainProps = showDirtyConfirm => {
    const { loading } = this.props;
    let toolbox = {
      backButtonProps: {
        path: this.getRootUrl(),
      },
      rightButtons: [
        {
          content: 'Save',
          onClick: this.handleAssignSubmit,
          disabled:
            loading ||
            isPreferenceDisabled(
              PrefEnum.AssignUsers,
              this.props.security.preferences
            ),
        },
      ],
      shown: true,
    };
    return {
      toolbox,
    };
  };
  componentWillUnmount() {
    this.props.clearAssignSiteData();
    this.props.resetDirty();
  }
  render() {
    const { handleAssignSubmit, loading, isReadOnly } = this.props;
    const { description } = this.props.match.params;
    return (
      <Fragment>
        <Filter title={'Assign User(s) to a Site'} />
        <DirtyWrapper isReadOnly={isReadOnly}>
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <Header
                icon="user outline"
                style={{
                  color: '#df5a17',
                }}
                content={`Assign users to site - ${description}`}
              />
              <AssignUserGrid
                handleAssignSubmit={handleAssignSubmit}
                loading={loading}
                isReadOnly={isReadOnly}
              />
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { assignUsers } = state.SiteSetupState;
  return {
    security: state.SecurityState,
    assignUserData: assignUsers.data,
    loading: assignUsers.loading,
  };
};

export const AssignUserPageContainer = connect(
  mapStateToProps,
  { clearAssignSiteData, postUsersHaveAccess, getUsersForAssign, resetDirty }
)(AssignUserPage);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/AssignUserPage.js